import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';

import { isEqual, get } from 'lodash-es';
import { fromJS } from 'immutable';

import { withSnackbar } from 'notistack';

import { CircularProgress } from 'react-md';
import { ProductDocuments } from '@coog/react-components';

import * as productsActions from '../../Services/Products/actions';
import BlockInfos from './BlockInfos/BlockInfos';
import BlockCoverages from './BlockCoverages/BlockCoverages';

import './EditProduct.scss';
import BlockPackages from './BlockPackages/BlockPackages';

class EditProduct extends Component {
  constructor(props) {
    super(props);

    this.state = {
      product: {
        id: undefined,
      },
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let nextState = null;
    const { product: prevProduct } = prevState;
    const { products } = nextProps;
    if (prevProduct && typeof prevProduct.id !== 'undefined' && products) {
      const nextProduct = products.getIn([prevProduct.id]) ? products.getIn([prevProduct.id]).toJS() : undefined;
      if (nextProduct && !isEqual(nextProduct, prevProduct)) {
        nextState = { product: { id: prevProduct.id, ...nextProduct } };
      }
    }

    return nextState;
  }

  componentDidMount() {
    const { match } = this.props;
    this.setState({
      product: {
        id: match.params.id,
      },
    });
    this.fetchData(match.params.id);
  }

  componentDidUpdate(prevProps) {
    const { alerts: prevAlerts } = prevProps;
    const { alerts } = this.props;

    if (alerts && !isEqual(alerts.toJS(), prevAlerts.toJS())) {
      this.showAlerts();
    }
  }

  fetchData = id => {
    const { actions } = this.props;
    actions.fetchCommercialProductsV2();
    actions.fetchCommercialProduct({ id })
  };

  showAlerts = () => {
    const { enqueueSnackbar, alerts, strings } = this.props;
    if (enqueueSnackbar && alerts) {
      const errors = alerts.get('errors') ? alerts.get('errors').toJS() : undefined;
      const warnings = alerts.get('warnings') ? alerts.get('warnings').toJS() : undefined;
      const infos = alerts.get('infos') ? alerts.get('infos').toJS() : undefined;
      const successes = alerts.get('successes') ? alerts.get('successes').toJS() : undefined;
      if (Array.isArray(errors) && errors.length > 0) {
        errors.forEach(msg => {
          enqueueSnackbar(strings[msg] || msg, { variant: 'error' });
        });
      }
      if (Array.isArray(warnings) && warnings.length > 0) {
        warnings.forEach(msg => {
          enqueueSnackbar(strings[msg] || msg, { variant: 'warning' });
        });
      }
      if (Array.isArray(infos) && infos.length > 0) {
        infos.forEach(msg => {
          enqueueSnackbar(strings[msg] || msg, { variant: 'info' });
        });
      }
      if (Array.isArray(successes) && successes.length > 0) {
        successes.forEach(msg => {
          enqueueSnackbar(strings[msg] || msg, { variant: 'success' });
        });
      }
    }
  };

  updateProductId = id => {
    this.setState({
      product: {
        id,
      },
    });
    this.fetchData(id);
  };

  render() {
    const { pageTitle, canonical, strings, commercialproductsV2 } = this.props;
    const { product } = this.state;

    const productV2 = commercialproductsV2
      .toJS()
      .filter(cp => get(product, 'code') === get(cp, 'technical_product.code'))[0];
    const name = get(productV2, 'name', '');

    const titleLabel = title =>
      name ? (
        <>
          {title}
          <span className="product-name">{name}</span>
        </>
      ) : (
        title
      );
    const helmet = (
      <Helmet>
        <meta charSet="utf-8" />
        <title>{strings[pageTitle] || 'Product'}</title>
        <meta name="description" content={strings[pageTitle] || 'Product'} />
        <link rel="canonical" href={canonical} />
      </Helmet>
    );

    const handleClick = ({ url }) => {
      window.open(url);
    };

    return (
      <div className="coog-app product">
        {helmet}
        <h1 className="md-title md-cell md-cell--12">{titleLabel(strings[pageTitle] || 'Product')}</h1>
        <div className="md-body  edit-product">
          {product && product.code ? (
            <>
              <BlockInfos product={product} productV2={productV2} strings={strings} id={`infos-${product.id}`} />
              <BlockCoverages
                id={`coverages-${productV2.id}`}
                product={product}
                strings={strings}
              />
              <BlockPackages
                id={`coverages-${productV2.id}`}
                product={product}
                strings={strings}
              />
              <ProductDocuments title={pageTitle} product={productV2} strings={strings} onRoute={handleClick} />
            </>
          ) : (
            <CircularProgress id="product-loading" className="loading" scale={3} style={{ margin: '2em auto' }} />
          )}
        </div>
      </div>
    );
  }
}

EditProduct.propTypes = {
  pageTitle: PropTypes.string,
  canonical: PropTypes.string,
  strings: PropTypes.objectOf(PropTypes.string),
  actions: PropTypes.shape({
    getRoute: PropTypes.func,
    fetchCommercialProductsV2: PropTypes.func,
    fetchCommercialProduct: PropTypes.func,
    fetchCommercialProductCoverages: PropTypes.func,
    // fetchProductExtras: PropTypes.func,
    fetchProductInsuranceKind: PropTypes.func,
    fetchProductFamily: PropTypes.func,
  }),
  match: ReactRouterPropTypes.match.isRequired,
  products: PropTypes.object, // eslint-disable-line
  commercialproductsV2: PropTypes.object, // eslint-disable-line
  i18n: PropTypes.object, // eslint-disable-line
  // family: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  insuranceKind: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  loading: PropTypes.object, // eslint-disable-line
  enqueueSnackbar: PropTypes.func.isRequired, // eslint-disable-line
  alerts: PropTypes.object, // eslint-disable-line
};

EditProduct.defaultProps = {
  pageTitle: 'title.product',
  canonical: 'http://www.coopengo.com/',
  strings: {},
  actions: {
    getRoute: () => {},
  },
  products: fromJS({}),
  commercialproductsV2: fromJS({}),
  i18n: fromJS({}),
  loading: fromJS({}),
  alerts: fromJS({ warnings: [], errors: [], successes: [], infos: [] }),
  // family: fromJS({}),
  insuranceKind: fromJS({}),
};
// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => ({
  alerts: state.getIn(['products', 'alerts']),
  strings: state.getIn(['products']).toJS().strings,
  products: state.getIn(['products', 'products']),
  commercialproductsV2: state.getIn(['products', 'commercialproductsV2']),
  loading: state.getIn(['products', 'loading']),
  i18n: state.getIn(['system', 'i18n']),
  family: state.getIn(['products', 'family']),
  insuranceKind: state.getIn(['products', 'insuranceKind']),
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...productsActions }, dispatch),
});

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(EditProduct)));
